import { type IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';
import styles from './styles.scss';

export const IconThumbsUp = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={iconStyles({ ...props, className: styles.thumbsUp })}
  >
    <path d="M.9 20.4v-9.1c0-.6.4-1 1-1h3.5c.5 0 1 .4 1 1v11c0 .5-.5 1-1 1H1.8a1 1 0 0 1-1-1" />
    <path d="M7.6 10.4c1.2-1.1 2.8-2.8 3.5-4 .9-1.7 1.7-5 2.3-5.5s2-1.1 3 .9-2 8.2-2 8.2h6.5c.9 0 1.7.4 2 1.1.2.3.2.6.2 1 0 1.3-1 1.7-1.3 1.7 0 0 2 2.6-.7 3.4 0 0 1.5 2.8-1 3.5 0 0 1 2.5-1.3 2.9h-7.2c-1 0-2-.3-2.9-.8l-2.3-1.2" />
  </svg>
);
